import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Returns_ds_find_licenseplatesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { ids?: number[], shipmentIds?: number[], shippingContainerIds?: number[], archived?: boolean, statusIds?: number[], locationIds?: number[], typeIds?: number[], warehouseIds?: number[] }): 
  Promise<{ result: { Id?: number, Archived?: boolean, LocationId?: number, LookupCode?: string, ShipmentId?: number, ShippingContainerId?: number, StatusId?: number, TypeId?: number, WarehouseId?: number }[] }> 
  {
    let url = `${environment.backendUrl}api/Returns/datasources/ds_find_licenseplates/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { ids?: number[], shipmentIds?: number[], shippingContainerIds?: number[], archived?: boolean, statusIds?: number[], locationIds?: number[], typeIds?: number[], warehouseIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Archived?: boolean, LocationId?: number, LookupCode?: string, ShipmentId?: number, ShippingContainerId?: number, StatusId?: number, TypeId?: number, WarehouseId?: number }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Returns/datasources/ds_find_licenseplates/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { ids?: number[], shipmentIds?: number[], shippingContainerIds?: number[], archived?: boolean, statusIds?: number[], locationIds?: number[], typeIds?: number[], warehouseIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, Archived?: boolean, LocationId?: number, LookupCode?: string, ShipmentId?: number, ShippingContainerId?: number, StatusId?: number, TypeId?: number, WarehouseId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/datasources/ds_find_licenseplates/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      ids?: number[], shipmentIds?: number[], shippingContainerIds?: number[], archived?: boolean, statusIds?: number[], locationIds?: number[], typeIds?: number[], warehouseIds?: number[]    }) {
      return false;
    }
}
